"use client"

import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"
import { CommonStylesProps } from "../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../lib/helper"

export interface ButtonProps extends CommonStylesProps {
  type: "primary" | "secondary" | "tertiary"
  size?: "small" | "medium" | "large"
  text?: string
  link?: string
}

const defaultStyles = {
  primary: {
    padding: "12px 32px",
    borderRadius: "100px",
    fontSize: "16px",
    fontWeight: "600",
    color: "#fff",
    hoverTextColor: "#1E4259",
    backgroundColor: "#1E4259",
    hoverBgColor: "#fff",
    border: "1px solid #1E4259",
    lineHeight: "22px",
  },
  secondary: {
    padding: "12px 32px",
    borderRadius: "100px",
    fontSize: "16px",
    fontWeight: "600",
    color: "#1E4259",
    hoverTextColor: "#fff",
    backgroundColor: "#fff",
    hoverBgColor: "#1E4259",
    border: "1px solid #fff",
    lineHeight: "22px",
  },
  tertiary: {
    padding: "12px 20px",
    borderRadius: "4px",
    fontSize: "16px",
    fontWeight: "700",
    color: "#1E4259",
    hoverTextColor: "#fff",
    backgroundColor: "#fff",
    hoverBgColor: "#1E4259",
    border: "1px solid #fff",
    lineHeight: "22px",
  },
}

const mobileStyles = {
  primary: {
    padding: "8px 24px",
    fontSize: "14px",
    lineHeight: "20px",
  },
  secondary: {
    padding: "8px 24px",
    fontSize: "14px",
    lineHeight: "20px",
  },
  tertiary: {
    padding: "8px 20px",
    fontSize: "14px",
    lineHeight: "20px",
  },
}

export const RenderConfig: ComponentConfig<ButtonProps> = {
  render: ({ type, size, text, className, styles, responsiveType, link }: ButtonProps) => {
    const id = `button-${Math.random().toString(36).substr(2, 9)}`

    const buttonStyles = { ...defaultStyles[type] }
    const mobileButtonStyles = { ...mobileStyles[type] }

    const mergedStyles = {
      mobile: { ...buttonStyles, ...mobileButtonStyles, ...styles?.mobile },
      tablet: { ...buttonStyles, ...styles?.tablet },
      desktop: { ...buttonStyles, ...styles?.desktop },
    }

    const responsiveCSS = generateResponsiveCSS(id, mergedStyles || {}, responsiveType)

    return (
      <>
        {responsiveCSS}
        <a href={link ?? "#"} className={`${id} ${twMerge(className)} `}>
          <span>{text}</span>
        </a>
      </>
    )
  },
}
